import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import React, { Fragment } from 'react';
import './ModalPaymentSuccess.scss';
/**
 * @component ModalPaymentSuccess
 * @since 1.0.0
 * @hidden
 */
export function ModalPaymentSuccess(props) {
    var _a, _b, _c, _d, _e, _f;
    const { deal, onClose, hasDeposit } = props;
    /**
     * @function onDownload
     * @since 1.0.0
     * @hidden
     */
    function onDownload() {
        if (deal === null || deal === void 0 ? void 0 : deal.id) {
            window.open(`/orders/confirmation/${deal.id}`, '_blank');
        }
    }
    const retailerHref = ((_b = (_a = deal === null || deal === void 0 ? void 0 : deal.user) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.href) || ((_d = (_c = deal === null || deal === void 0 ? void 0 : deal.user) === null || _c === void 0 ? void 0 : _c.account) === null || _d === void 0 ? void 0 : _d.website);
    const retailerName = (_f = (_e = deal === null || deal === void 0 ? void 0 : deal.user) === null || _e === void 0 ? void 0 : _e.account) === null || _f === void 0 ? void 0 : _f.name;
    const footerActions = hasDeposit ? (React.createElement(Fragment, null,
        React.createElement(Button, { size: "large", label: t('Close'), style: "primary", onPress: onClose }))) : (React.createElement(Fragment, null,
        React.createElement(Button, { picto: "file-pdf", size: "large", label: t('Download Order Confirmation'), style: "primary", onPress: onDownload }),
        retailerHref && (React.createElement(Button, { size: "large", label: t('Continue to navigate on the website of') + ' ' + retailerName, style: "outline", onPress: () => {
                if (retailerHref.includes('http') ||
                    retailerHref.includes('https')) {
                    window.location.href = retailerHref;
                }
                else {
                    window.location.href = 'https://' + retailerHref;
                }
            } })),
        React.createElement(Button, { size: "large", label: t('Close'), style: "outline", onPress: onClose })));
    return (React.createElement("div", { className: "modal-payment-success" },
        React.createElement(Modal, { picto: "circle-check", title: t('Payment Successful!'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-payment-success-content" }, hasDeposit ? (React.createElement(React.Fragment, null,
                React.createElement("p", null, t('Your deposit payment has been processed successfully.')),
                React.createElement("br", null),
                React.createElement("p", null, t('A confirmation email has been sent to you.')))) : (React.createElement(React.Fragment, null,
                React.createElement("p", null, t('Your payment has been processed successfully. You can now download your order confirmation.')),
                React.createElement("br", null),
                React.createElement("p", null, t('An email has been sent to you for your order confirmation.')),
                React.createElement("br", null),
                React.createElement("p", null,
                    React.createElement("a", { href: `/documentation`, target: "_blank", rel: "noopener noreferrer" }, t('Troubles with downloading your order confirmation?')))))))));
}
